import React from 'react';
import {
  ResponsiveContainer,
  CartesianGrid,
  BarChart,
  XAxis,
  YAxis,
  Tooltip,
  Bar,
} from 'recharts';

const ProductChart = (props) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  const { data = [], slice = 7, type = 'PRODUCT' } = props;

  /* ===== State ===== */
  /* ===== Hooks ===== */
  /**
   * 일자별 차트 데이터 정제
   * --
   */
  const chartData = React.useMemo(() => {
    if (!data.length) return [];

    const filterData = data.filter(
      (_item) => _item.type === type && _item.payment_state === 'COMPLETED'
    );

    const dateData = filterData.reduce((acc, cur) => {
      const { product, payment_price } = cur;

      const idx = product[`${type.toLocaleLowerCase()}_id`];

      if (acc[idx]) {
        acc[idx] = {
          ...acc[idx],
          TOTAL: acc[idx]['TOTAL'] + payment_price,
        };
      } else {
        acc[idx] = {
          NAME: product[`${type.toLocaleLowerCase()}_name`],
          TOTAL: payment_price,
        };
      }

      return acc;
    }, {});

    const mappingData = Object.values(dateData).sort(
      (a, b) => b['TOTAL'] - a['TOTAL']
    );

    return mappingData.slice(0, slice);
  }, [data, slice, type]);

  /* ===== Function ===== */
  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  /* ===== Render ===== */
  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        width={500}
        height={500}
        data={chartData}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="NAME" />
        <YAxis />
        <Tooltip />
        <Bar dataKey="TOTAL" stackId="a" fill="#82ca9d" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default ProductChart;
